// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"326":"46a8055bbf36bca72bd7","564":"77588b0dbaf568663f34","583":"4381dc10e8399d06ad99"}[chunkId] + ".css";
};